import { ResourceAppModule } from "@/shared/app";
import { plmApp } from "../app";
import {
  rodzajKomponentuResource,
  RodzajKomponentu,
} from "@megarax/client/src/resources/plm";

export const rodzajKomponentuModule: ResourceAppModule = {
  app: plmApp,
  formComponent: () => import("./ItemForm.vue"),
  sheetComponent: () => import("./ItemSheet.vue"),
  listComponent: () => import("./ItemList.vue"),
  iconClass: "fas fa-tint fa-fw",
  title: "Rodzaje komponentów",
  route: "rodzajKomponentu",
  itemConstructor: RodzajKomponentu,
  resource: rodzajKomponentuResource,
};
